module.exports = __webpack_public_path__ + "static/media/portada_cirerer.5485d3c3.jpg";